import createClient, { type Middleware } from "openapi-fetch";
import type { paths } from "@dolfin/api-admin";

let activeClientId: string | null = null;

export function setActiveClientId(clientId: string | null): void {
  activeClientId = clientId;
}

const clientIdHeader: Middleware = {
  onRequest({ request }) {
    // Default to the page's active client, but never override a per-request x-dolfin-client-id.
    if (activeClientId && !request.headers.has("x-dolfin-client-id")) {
      request.headers.set("x-dolfin-client-id", activeClientId);
    }
    return request;
  },
};

export const api = createClient<paths>({
  baseUrl: "/api/proxy",
});

api.use(clientIdHeader);
